import { isFunction } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { ensureObject } from 'utils/objects';

import { DEFAULT } from 'modules/ElementaryCareers/constants';
import {
  getAudio,
  setTtsEnabledStatus,
} from 'modules/ElementaryCareers/selectors';

const useStopPlayingReadAloud = () => {
  const dispatch = useDispatch();
  const { playingItem, ttsEnabledItems, audioFiles } = useSelector(
    state => state?.textToSpeech,
  );

  return () => {
    // Check if there is an item playing and pause it
    if (!ttsEnabledItems[playingItem]) {
      return;
    }
    const { url, id } = ensureObject(ttsEnabledItems?.[playingItem]);
    const audio = getAudio({ id, url, audioFiles, dispatch });

    if (audio && isFunction(audio.pause)) {
      audio.currentTime = 0;
      audio.pause();
      setTtsEnabledStatus(id, DEFAULT);
    }
  };
};

export default useStopPlayingReadAloud;
